import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography, useTheme } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
var SearchAccordion = function (_a) {
    var title = _a.title, content = _a.content, icon = _a.icon, expanded = _a.expanded, onToggle = _a.onToggle;
    var theme = useTheme();
    var handleChange = function () {
        onToggle();
    };
    return (_jsxs(Accordion, { sx: {
            boxShadow: 'none',
            '&:before': { display: 'none' },
            '&.Mui-expanded': { margin: 0 }
        }, expanded: expanded, onChange: handleChange, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMore, {}), sx: {
                    borderBottom: expanded ? 'none' : '1px solid',
                    borderColor: 'divider',
                    minHeight: '48px !important',
                    '& .MuiAccordionSummary-content': { margin: 0 }
                }, children: _jsxs(Box, { display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center', children: [icon, _jsx(Typography, { variant: 'subtitle1', color: theme.palette.text.primary, children: title })] }) }), _jsx(AccordionDetails, { sx: { padding: 0 }, children: content })] }));
};
export default SearchAccordion;
